import React, { useEffect, useState } from 'react'
import axiosInstance from '../services/axiosComman';

function useGetStandardDetail({id}) {
  const [standardDetailName, setStandardDetailName] = useState("");
  const [standardStartDate, setStandardStartDate] = useState("")
  const [standardEndDate, setStandardEndDate] = useState("")

  async function getData(){
    await axiosInstance.get(`Standards/${id}`).then(res=>{
        setStandardDetailName(res?.data?.data.name);
        setStandardStartDate(res?.data?.data.start_date);
        setStandardEndDate(res?.data?.data.end_date)
    }).catch(err=>{
        console.log(err)
    })
  }


  useEffect(()=>{
    if(id)getData()
  },[id])

  return {standardDetailName,standardStartDate,standardEndDate}
}

export default useGetStandardDetail;